import { liabilityPolicyLimitsOptions, medPayPolicyLimitsOptions, umPolicyLimitsOptions } from "../../../lib/systemData"
import { isLightColor, isStateOfPip } from "../../../lib/script"
import classesCell from './BodyCell.module.css'

export default function LimitsCell({data, itemKey, caseData}) {
    const numericValue = Number(`${data ?? ''}`.replace(/,/g, ''))

    let text = null;
    let color = null;
    let textColor = null;
    let bkColor = null;
    let noDataCell = false;

    if (!Number.isNaN(numericValue) && Number.isFinite(numericValue) && data !== null && data !== '') {
        text = { label: `$${numericValue.toLocaleString()}` }
    } else if (itemKey === 'liability_policy_limit') {
        const options = liabilityPolicyLimitsOptions();
        if (options) {
            const item = options.find(item => item.value == data);
            if (item) {
                text = item;
            }
        }
    } else if (itemKey === 'medpay_mp_limit') {
        const options = medPayPolicyLimitsOptions();
        if (options) {
            const item = options.find(item => item.value == data);
            if (item) {
                text = item;
            }
        }
    } else if (itemKey === 'medpay_pip_limit') {
        if (isStateOfPip(caseData?.mp_pip?.insurance_state ?? caseData?.mp_pip_um?.find(r => r.is_primary_insurance)?.insurance_state)) {
            const options = medPayPolicyLimitsOptions();
            if (options) {
                const item = options.find(item => item.value == data);
                if (item) {
                    text = item;
                }
            }
        } else {
            noDataCell = true;
        }
    } else if (itemKey === 'um_um_limit') {
        const options = umPolicyLimitsOptions();
        if (options) {
            const item = options.find(item => item.value == data);
            if (item) {
                text = item;
            }
        }
    }

    if (text && text.color) {
        color = text.color.split(" ").join("_");
    }

    if (text && text.color_code) {
        bkColor = text.color_code;
        let lightDark = isLightColor(text.color_code);
        textColor = lightDark ? 'var(--text)' : 'var(--white)';
    } else {
        textColor = null;
        bkColor = null;
    }


    // old code
    // const [text, setText] = useState(null)
    // const [color, setColor] = useState(null)
    // const [textColor, setTextColor] = useState(null)

    // const [bkColor, setBkColor] = useState(null)
    // const [noDataCell, setNoDataCell] = useState(false)

    // useEffect(() => {
    //     if (itemKey == 'liability_policy_limit') {
    //         let options = liabilityPolicyLimitsOptions()

    //         if (options) {
    //             let item = options.find(item => item.value == data)
    //             if (item) {
    //                 setText(item)
    //             }
    
    //         }
    //     }

    //     if (itemKey == 'medpay_mp_limit') {
    //         let options = medPayPolicyLimitsOptions()

    //         if (options) {
    //             let item = options.find(item => item.value == data)
    //             if (item) {
    //                 setText(item)
    //             }
    
    //         }
    //     }

    //     if (itemKey == 'medpay_pip_limit') {
    //         if (isStateOfPip(caseData?.case?.state)) {
    //             let options = medPayPolicyLimitsOptions()

    //             if (options) {
    //                 let item = options.find(item => item.value == data)
    //                 if (item) {
    //                     setText(item)
    //                 }
        
    //             }
    //         } else {
    //             setNoDataCell(true)
    //         }
            
    //     }        

    //     if (itemKey == 'um_um_limit') {
    //         let options = umPolicyLimitsOptions()

    //         if (options) {
    //             let item = options.find(item => item.value == data)
    //             if (item) {
    //                 setText(item)
    //             }
    
    //         }
    //     }
        
    // }, [data, itemKey])

    // useEffect(() => {
    //     if (text && text.color) {
    //         setColor(text.color.split(" ").join("_"))       
    //     }

    //     if (text && text.color_code) {
    //         setBkColor(text.color_code)
    //         let lightDark = isLightColor(text.color_code)
    //         setTextColor(lightDark ? 'var(--text)' : 'var(--white)')            
    //     } else {
    //         setTextColor(null)
    //         setBkColor(null)
    //     }
    // }, [text])


    return <div style={{backgroundColor: bkColor, color: textColor}} className={`${classesCell.body_cell} ${color ? 'bk_' + color : ''} ${noDataCell ? classesCell.no_data_cell : ''}`}>
        {text && text.label}
    </div>
}